import { ADD_TOAST, REMOVE_TOAST } from '@state/actions/toastsAction'

/**
 * Initial state
 */
const initialToastsState = {
    toasts: [],
}

/**
 * Reducer
 */
const toastsReducer = (state, action) => {
    switch (action.type) {
        case ADD_TOAST:
            return {
                ...state,
                toasts: [...state.toasts, action.payload],
            }

        case REMOVE_TOAST:
            return {
                ...state,
                toasts: state.toasts.filter(
                    (toast) => toast.id !== action.payload
                ),
            }

        default:
            return state
    }
}

export { toastsReducer, initialToastsState }
